import { createStringLocalStorageState } from './manager';

export const encryptedBasicAuthGlobalState = createStringLocalStorageState('encryptedBasicAuth');
